module.exports = __webpack_public_path__ + "img/05_kudo_09.6853ea45.jpg";